import * as React from 'react';
import Button from "@mui/material/Button";
import SaveAsIcon from '@mui/icons-material/SaveAs';
import SaveFiltersDialog from '../Filtering/SaveFiltersDialog';
import CallTableViewModel from '../ViewModels/CallTableViewModel';

interface ISaveFiltersDialogProps {
    callTableViewModel: CallTableViewModel;
    toggleNewFilter?: () => void;
}

export default function SavedSelectedFiltersButton(props: ISaveFiltersDialogProps) {
    const [openSaveFilterDialog, setOpenSaveFilterDialog] = React.useState<boolean>(false);

    const handleOpenSaveFilterDialog = () => {
        setOpenSaveFilterDialog(true);
    }

    const handleCloseSaveFilterDialog = () => {
        setOpenSaveFilterDialog(false);
    }

    return (
        <>
            <Button onClick={handleOpenSaveFilterDialog} size="small" variant="contained" color="secondary" sx={{ boxShadow: '0 0 0' }}>
                <SaveAsIcon />
            </Button>
            <SaveFiltersDialog
                open={openSaveFilterDialog}
                close={handleCloseSaveFilterDialog}
                callTableViewModel={props.callTableViewModel}
                toggleNewFilter={props.toggleNewFilter} />
        </>
    )
}